import React, { Component } from "react";
import CustomButton from "../components/CustomButton";
import UserGroupItem from "../components/UserGroupItem";
import MessageItem from "../components/MessageItem";
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
// import {Form} from 'react-bootstrap'
import { WhisperSpinner } from "react-spinners-kit";

export default class ListViewer extends Component {
  constructor(props) {
    super(props);

    let listt = JSON.parse(JSON.stringify(this.props.list));
    this.state = {
      list: listt,
      selectAll: false,
    };
    this.updateList = this.updateList.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.list !== prevProps.list) {
      // console.log(this.props.list);

      this.setState({ list: this.props.list }, () => {
        this.updateList();
      });
    }
  }

  componentDidMount() {
    this.updateList();
    // console.log(this.props.list);
  }

  updateList() {
    // let list = [...this.props.list];
    let list = JSON.parse(JSON.stringify(this.state.list));
    // console.log("list: ", list);
    // console.log("currentSelected: ", this.props.currentSelected);
    let selectall = true;
    list.forEach((element) => {
      if (this.props.listType === "product") {
        let allselectgroup = true;
        element.items.forEach((element1) => {
          this.props.currentSelected.forEach((element2) => {
            if (element1.id === element2.id) {
              element1.selected = element2.selected;
              element1.packingPrice = element2.packingPrice;
              element1.taxPercent = element2.taxPercent;
            }
          });
          if (!element1.selected) allselectgroup = false;
        });
        if (allselectgroup) element.selected = true;
      } else {
        this.props.currentSelected.forEach((element1) => {
          if (element.id === element1) element.selected = true;
        });
      }

      if (!element.selected) selectall = false;
    });
    // console.log(list);
    this.setState({ list: list, selectAll: selectall });
  }

  onConfirm() {
    let list = [];
    // console.log("====================================");
    // console.log(this.state.list);
    // console.log("====================================");
    this.state.list.forEach((element) => {
      if (this.props.listType === "product") {
        element.items.forEach((element1) => {
          if (element1.selected) {
            list.push(element1);
          }
        });
      } else {
        if (
          element.selected &&
          (this.props.listType === "message" ||
            this.props.withPrice ||
            this.props.withPercent)
        )
          list.push(element);
        else if (element.selected) list.push(element.id);
      }
    });

    switch (this.props.listType) {
      case "group": {
        this.props.onConfirmGroups(list);
        break;
      }
      case "category": {
        this.props.onConfirmCategory(list);
        break;
      }
      case "product": {
        this.props.onConfirmProduct(list);
        break;
      }
      case "cat": {
        this.props.onConfirmProduct(list);
        break;
      }
      case "station": {
        this.props.onConfirmStation(list);
        break;
      }
      case "message": {
        this.props.onConfirmMessage(list);
        break;
      }
      case "place": {
        this.props.onConfirmPlace(list);
        break;
      }
      case "pattern": {
        this.props.onConfirmPattern(list);
        break;
      }
      case "orderProcess": {
        this.props.onConfirmOrderProcess(list);
        break;
      }
      case "user": {
        this.props.onConfirmUser(list);
        break;
      }
      case "printer": {
        this.props.onConfirmPrinter(list);
        break;
      }
      default:
        break;
    }
  }

  hideModal() {
    this.props.hideModal();
  }

  iSelected(id, price) {
    let list = JSON.parse(JSON.stringify(this.state.list));
    list.forEach((element) => {
      if (element.id === id) {
        if (!element.selected) {
          element.selected = true;
          if (this.props.listType === "product") {
            element.items.forEach((element1) => {
              element1.selected = true;
              if (price) {
                if (this.props.withPrice) element1.packingPrice = price;
                else if (this.props.withPercent) element1.taxPercent = price;
              } else if (price === 0) {
                element1.selected = false;
                element1.packingPrice = 0;
                element1.taxPercent = 0;
              }
            });
          }
        } else if (
          this.props.listType !== "message" ||
          this.props.listType !== "place" ||
          this.props.listType !== "printer" ||
          this.props.listType !== "pattern"
        ) {
          element.selected = false;
          this.setState({ selectAll: false });
          if (this.props.listType === "product") {
            element.items.forEach((element1) => {
              element1.selected = false;
              element1.packingPrice = 0;
              element1.taxPercent = 0;
            });
          }
        }

        if (this.props.listType === "product") {
          if (price) {
            if (this.props.withPrice) element.packingPrice = price;
            else if (this.props.withPercent) element.taxPercent = price;
          } else if (price === 0) {
            element.selected = false;
            element.packingPrice = 0;
            element.taxPercent = 0;
          }
        }
      } else if (
        this.props.listType === "message" ||
        this.props.listType === "place" ||
        this.props.listType === "printer" ||
        this.props.listType === "pattern"
      ) {
        element.selected = false;
      }
    });
    // console.log("====================================");
    // console.log(list);
    // console.log("====================================");
    this.setState({ list: list });
  }

  selectAll(id, price) {
    this.setState({ selectAll: !this.state.selectAll }, () => {
      let list = JSON.parse(JSON.stringify(this.state.list));
      list.forEach((element) => {
        if (this.props.listType === "product") {
          element.items.forEach((element1) => {
            if (this.state.selectAll) {
              element1.selected = true;
              if (price && this.props.withPrice) element1.packingPrice = price;
              else if (price && this.props.withPercent)
                element1.taxPercent = price;
              else if (price === 0) {
                element1.packingPrice = 0;
                element1.taxPercent = 0;
              }
            } else {
              element1.selected = false;
              element1.packingPrice = 0;
              element1.taxPercent = 0;
            }
          });
        }
        element.selected = this.state.selectAll;
      });
      this.setState({ list: list });
    });
  }

  iSelectedProduct(id, price) {
    let list = JSON.parse(JSON.stringify(this.state.list));
    list.forEach((element) => {
      element.items.forEach((element1) => {
        if (element1.id === id) {
          if (!element1.selected) {
            element1.selected = true;
            if (price && this.props.withPrice) element1.packingPrice = price;
            else if (price && this.props.withPercent)
              element1.taxPercent = price;
            else if (price === 0) {
              element1.selected = false;
              element1.packingPrice = 0;
              element1.taxPercent = 0;
            }
          } else {
            this.setState({ selectAll: false });
            element.selected = false;
            element1.selected = false;
            element1.packingPrice = 0;
            element1.taxPercent = 0;
          }
        }
      });
    });

    this.setState({ list: list });
  }

  render() {
    return (
      <div className="listViewer">
        {!this.props.loading && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              maxHeight: "400px",
              overflow: "auto",
              padding: "0px 5px",
            }}
          >
            {this.props.listType === "orderProcess" && this.props.title && (
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "var(--black1)",
                  marginBottom: "15px",
                }}
              >
                {this.props.title}
              </div>
            )}

            {this.props.listType !== "message" &&
              this.props.listType !== "place" &&
              this.props.listType !== "printer" &&
              this.props.listType !== "pattern" &&
              this.state.list.length > 1 && (
                <div style={{ width: "100%" }}>
                  <UserGroupItem
                    notShowIcon
                    selected={this.state.selectAll}
                    name="انتخاب همه"
                    onSelected={this.selectAll.bind(this)}
                    withPrice={this.props.withPrice}
                    withPercent={this.props.withPercent}
                    border="1px solid var(--gray3)"
                    rtlPriceTitle={this.props.rtlPriceTitle}
                  />
                </div>
              )}
            {/*{(this.props.listType === "cat" ||
              this.props.listType === "station" ||
              this.props.listType === "user") && ( */}
            {this.props.listType !== "message" &&
              this.props.listType !== "place" &&
              this.props.listType !== "printer" &&
              this.props.listType !== "pattern" &&
              this.state.list.length > 1 && (
                <div
                  style={{
                    width: "100%",
                    minHeight: "1px",
                    backgroundColor: "var(--white)",
                    margin: "5px 0px",
                  }}
                />
              )}

            {this.state.list
              .filter((child) =>
                this.props.listType === "message"
                  ? child.isConfirmedBySepand
                  : child
              )
              .map((item, i) => {
                if (
                  this.props.listType === "message" ||
                  this.props.listType === "place" ||
                  this.props.listType === "printer" ||
                  this.props.listType === "pattern"
                ) {
                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <MessageItem
                        index={i}
                        id={item.id}
                        selected={item.selected}
                        name={
                          this.props.listType === "place" ? (
                            item.titleFa
                          ) : this.props.listType === "pattern" ? (
                            item.title
                          ) : this.props.listType === "printer" ? (
                            item.label ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "5px",
                                }}
                              >
                                {item.label}
                                <span style={{ fontSize: "10px" }}>
                                  ({item.printerName})
                                </span>
                              </div>
                            ) : (
                              item.printerName
                            )
                          ) : (
                            item.text
                          )
                        }
                        onSelected={this.iSelected.bind(this, item.id)}
                      />
                    </div>
                  );
                } else {
                  // console.log(item);
                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <UserGroupItem
                        index={i}
                        notShowIcon
                        id={item.id}
                        selected={item.selected}
                        name={
                          this.props.listType === "orderProcess"
                            ? item.title
                            : this.props.listType === "user"
                            ? item.userName
                            : item.name
                        }
                        onSelected={this.iSelected.bind(this)}
                        withPrice={this.props.withPrice}
                        withPercent={this.props.withPercent}
                        item={item}
                        rtlPriceTitle={this.props.rtlPriceTitle}
                      />
                      {this.props.listType === "product" &&
                        item.items.map((item1, i1) => {
                          return (
                            <div
                              key={i1}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <UserGroupItem
                                index={i1}
                                notShowIcon
                                id={item1.id}
                                selected={item1.selected}
                                name={
                                  this.props.listType === "orderProcess"
                                    ? item1.title
                                    : item1.name
                                }
                                onSelected={this.iSelectedProduct.bind(this)}
                                withPrice={this.props.withPrice}
                                withPercent={this.props.withPercent}
                                item={item1}
                                sub={true}
                                rtlPriceTitle={this.props.rtlPriceTitle}
                              />
                            </div>
                          );
                        })}
                    </div>
                  );
                }
              })}

            {this.props.listType === "message" &&
              this.state.list.filter((child) => child.isConfirmedBySepand)
                .length < 1 && (
                <div
                  style={{
                    padding: "20px 0px",
                    width: "100%",
                    textAlign: "center",
                    color: "var(--gray3)",
                  }}
                >
                  الگوی تایید شده‌ای وجود ندارد
                </div>
              )}

            {this.props.listType === "place" && this.state.list.length < 1 && (
              <div
                style={{
                  padding: "20px 0px",
                  width: "100%",
                  textAlign: "center",
                  color: "var(--gray3)",
                }}
              >
                محلی تعریف نشده است
              </div>
            )}

            {this.props.listType === "printer" &&
              this.state.list.length < 1 && (
                <div
                  style={{
                    padding: "20px 0px",
                    width: "100%",
                    textAlign: "center",
                    color: "var(--gray3)",
                  }}
                >
                  چاپگری تعریف نشده است
                </div>
              )}

            {this.props.listType === "pattern" &&
              this.state.list.length < 1 && (
                <div
                  style={{
                    padding: "20px 0px",
                    width: "100%",
                    textAlign: "center",
                    color: "var(--gray3)",
                  }}
                >
                  الگویی تعریف نشده است
                </div>
              )}
          </div>
        )}

        {!this.props.loading && (
          <div
            style={{
              width: "100%",
              maxWidth: "500px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: "20px",
              alignItems: "center",
            }}
          >
            {((this.props.listType === "message" &&
              this.state.list.filter((child) => child.isConfirmedBySepand)
                .length > 0) ||
              (this.props.listType !== "message" &&
                this.state.list.length > 0)) && (
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="تایید"
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  loading={this.props.buttonLoading}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
            )}
            {((this.props.listType === "message" &&
              this.state.list.filter((child) => child.isConfirmedBySepand)
                .length > 0) ||
              (this.props.listType !== "message" &&
                this.state.list.length > 0)) && (
              <div style={{ minWidth: "10px" }} />
            )}
            <div
              style={{
                flex:
                  (this.props.listType === "message" &&
                    this.state.list.filter((child) => child.isConfirmedBySepand)
                      .length > 0) ||
                  (this.props.listType !== "message" &&
                    this.state.list.length > 0)
                    ? "0.8"
                    : "1",
              }}
            >
              <CustomButton
                title="انصراف"
                imgHeight={19}
                backColor="var(--black1)"
                imgWidth={25}
                minHeight="35px"
                disabled={this.props.buttonLoading}
                img={Cancel}
                onClick={this.hideModal.bind(this)}
              />
            </div>
          </div>
        )}

        {this.props.loading && (
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
              minHeight: "200px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <WhisperSpinner
              size={30}
              color="var(--brown1)"
              frontColor="var(--brown1)"
              backColor="var(--brown1)"
              loading={true}
            />
          </div>
        )}
      </div>
    );
  }
}
